__webpack_require__.p = "https://lm-dynamic-price.lumoonix.com/";